export default "__VITE_ASSET__Cisns0Wa__"